import React, { memo, SVGProps } from 'react'

import { User, CommentItem, getShortName } from '@builddocs/data-management'
import { Tooltip } from '@mui/material'
import Avatar from '@mui/material/Avatar'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { format, formatDistanceToNow } from 'date-fns'
import { ru } from 'date-fns/locale'
import parseISO from 'date-fns/parseISO'

type OwnProps = {
  user: User
  comment: CommentItem
}

const DeadlineIcon = ({ ...rest }: SVGProps<any>) => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8 14.6668C10.7449 14.6668 12.9999 12.4916 12.9999 9.69953C12.9999 9.0141 12.9651 8.27933 12.5852 7.13736C12.2052 5.99543 12.1287 5.84803 11.727 5.1428C11.5553 6.58196 10.637 7.18176 10.4037 7.36103C10.4037 7.17453 9.84817 5.11213 9.00587 3.87813C8.179 2.66683 7.05447 1.87214 6.3951 1.3335C6.3951 2.35675 6.1073 3.87813 5.69513 4.6533C5.28297 5.42846 5.20557 5.4567 4.69073 6.03356C4.17593 6.61043 3.93963 6.7886 3.50913 7.48853C3.07865 8.1885 3 9.12076 3 9.8062C3 12.5982 5.2551 14.6668 8 14.6668Z"
      strokeLinejoin="round"
    />
  </svg>
)

export const UserCardInner = ({ user, comment }: OwnProps) => {
  const [avatar] = React.useState<string>('')

  // React.useEffect(() => {
  //   getAvatarSource(user.userId).then(avatar => setAvatar(avatar))
  // }, [])

  const deadlineExpired = comment?.deadline
    ? parseISO(comment?.deadline) >= new Date()
      ? 'ongoing'
      : 'expired'
    : undefined

  return (
    <Stack alignItems="center" direction="row" spacing={1}>
      <Avatar src={avatar} sx={{ width: 32, height: 32 }} variant="rounded" />
      <Stack>
        <Stack alignItems="center" direction="row" spacing={1}>
          <Typography variant="subtitle2">{getShortName(user)}</Typography>
          {comment?.deadline && (
            <Stack alignItems="center" direction="row" spacing={1}>
              <span
                style={{
                  height: 4,
                  width: 4,
                  borderRadius: '50%',
                  display: 'inline',
                  backgroundColor: '#bbbbbb',
                }}
              />
              <DeadlineIcon
                stroke={deadlineExpired === 'ongoing' ? '#888888' : '#F20404'}
              />
              <Typography
                color={deadlineExpired === 'expired' ? '#F20404' : '#888888'}
              >
                {format(parseISO(comment?.deadline), 'dd.MM.yyyy')}
              </Typography>
            </Stack>
          )}
        </Stack>
        <Tooltip
          placement="top"
          title={format(new Date(comment.createDateTime), 'PPpp', {
            locale: ru,
          })}
        >
          <Typography color="text.secondary" variant="body2">
            {formatDistanceToNow(new Date(comment.createDateTime), {
              locale: ru,
              addSuffix: true,
            })}
          </Typography>
        </Tooltip>
      </Stack>
    </Stack>
  )
}

export const UserCardInCommentCard = memo(UserCardInner)
